// extracted by mini-css-extract-plugin
export default {"successIcon":"sidebar-actions-module__successIcon--mz8Ty","successText":"sidebar-actions-module__successText--ae2Ea"};